module.exports = __webpack_public_path__ + "img/xlsx.316e2369.svg";